export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";